import { type BrandListItem } from '../types';
import brandsAssets from './brandAssets';
import { Brands } from './brands';

export const DEFAULT_BRAND = Brands.MYUPLINK;

export const hideClimatixIntegration = process.env.ENABLE_CLIMATIX_INTEGRATION !== 'true';

export const brandsList: BrandListItem[] = [
  {
    brand: Brands.AIT,
    url: brandsAssets[Brands.AIT].logo,
    hero: brandsAssets[Brands.AIT].hero,
    companyUrl: 'https://www.alpha-innotec.com/',
    hide: false,
  },
  {
    brand: Brands.BIAWAR,
    url: brandsAssets[Brands.BIAWAR].logo,
    hero: brandsAssets[Brands.BIAWAR].hero,
    companyUrl: 'https://www.biawar.com.pl/',
    hide: true,
  },
  {
    brand: Brands.CETETHERM,
    url: brandsAssets[Brands.CETETHERM].logo,
    hero: brandsAssets[Brands.CETETHERM].hero,
    companyUrl: 'https://www.cetetherm.com/',
    hide: false,
  },
  {
    brand: Brands.CLIMATEMASTER,
    url: brandsAssets[Brands.CLIMATEMASTER].logo,
    hero: brandsAssets[Brands.CLIMATEMASTER].hero,
    companyUrl: 'https://www.climatemaster.com/',
    hide: false,
  },
  {
    brand: Brands.CONTURA,
    url: brandsAssets[Brands.CONTURA].logo,
    hero: brandsAssets[Brands.CONTURA].hero,
    companyUrl: 'https://www.contura.eu/',
    hide: false,
  },
  {
    brand: Brands.CTA,
    url: brandsAssets[Brands.CTA].logo,
    hero: brandsAssets[Brands.CTA].hero,
    companyUrl: 'https://www.cta.ch',
    hide: false,
  },
  {
    brand: Brands.CTC,
    url: brandsAssets[Brands.CTC].logo,
    hero: brandsAssets[Brands.CTC].hero,
    companyUrl: 'https://ctc-heating.com/',
    hide: false,
  },
  {
    brand: Brands.DZD,
    url: brandsAssets[Brands.DZD].logo,
    hero: brandsAssets[Brands.DZD].hero,
    companyUrl: 'https://dzd.cz/',
    hide: true,
  },
  {
    brand: Brands.DANDELION,
    url: brandsAssets[Brands.DANDELION].logo,
    hero: brandsAssets[Brands.DANDELION].hero,
    companyUrl: 'https://dandelionenergy.com/',
    hide: true,
  },
  {
    brand: Brands.ENERTECH,
    url: brandsAssets[Brands.ENERTECH].logo,
    hero: brandsAssets[Brands.ENERTECH].hero,
    companyUrl: 'https://enertechusa.com/',
    hide: false,
  },
  {
    brand: Brands.HOIAX,
    url: brandsAssets[Brands.HOIAX].logo,
    hero: brandsAssets[Brands.HOIAX].hero,
    companyUrl: 'https://www.hoiax.no/',
    hide: false,
  },
  {
    brand: Brands.IEC,
    url: brandsAssets[Brands.IEC].logo,
    hero: brandsAssets[Brands.IEC].hero,
    companyUrl: 'https://iec-okc.com/',
    hide: false,
  },
  {
    brand: Brands.JAMA,
    url: brandsAssets[Brands.JAMA].logo,
    hero: brandsAssets[Brands.JAMA].hero,
    companyUrl: 'https://jaspi.fi/',
    hide: false,
  },
  {
    brand: Brands.JASPI,
    url: brandsAssets[Brands.JASPI].logo,
    hero: brandsAssets[Brands.JASPI].hero,
    companyUrl: 'https://jaspi.fi/',
    hide: false,
  },
  {
    brand: Brands.METROTHERM,
    url: brandsAssets[Brands.METROTHERM].logo,
    hero: brandsAssets[Brands.METROTHERM].hero,
    companyUrl: 'https://www.metrotherm.dk/',
    hide: true,
  },
  {
    brand: Brands.MHI,
    url: brandsAssets[Brands.MHI].logo,
    hero: brandsAssets[Brands.MHI].hero,
    companyUrl: 'https://www.mhi.com',
    hide: true,
  },
  {
    brand: Brands.NIBE,
    url: brandsAssets[Brands.NIBE].logo,
    hero: brandsAssets[Brands.NIBE].hero,
    companyUrl: 'https://www.nibe.eu/',
    hide: false,
  },
  {
    brand: Brands.NIBEF,
    url: brandsAssets[Brands.NIBE].logo, // NIBEF uses NIBE main logo for general representation
    hero: brandsAssets[Brands.NIBEF].hero,
    integrationsLogo: brandsAssets[Brands.NIBEF].logo, // This logo should be rendered on /works-with page as integrations and replace default NIBE logo
    companyUrl: '/nibeflow-integration',
    hide: hideClimatixIntegration,
  },
  {
    brand: Brands.AIRSITE,
    url: brandsAssets[Brands.AIRSITE].logo,
    hero: brandsAssets[Brands.AIRSITE].hero,
    companyUrl: 'http://www.nibeairsite.com/sv/',
    hide: false,
  },
  {
    brand: Brands.NOVELAN,
    url: brandsAssets[Brands.NOVELAN].logo,
    hero: brandsAssets[Brands.NOVELAN].hero,
    companyUrl: 'https://www.novelan.com/',
    hide: false,
  },
  {
    brand: Brands.ROTH,
    url: brandsAssets[Brands.ROTH].logo,
    hero: brandsAssets[Brands.ROTH].hero,
    companyUrl: 'https://www.roth-industries.com/',
    hide: false,
  },
  {
    brand: Brands.TEMPEFF,
    url: brandsAssets[Brands.TEMPEFF].logo,
    hero: brandsAssets[Brands.TEMPEFF].hero,
    companyUrl: 'https://www.tempeff.com/',
    hide: true,
  },
  {
    brand: Brands.TIKI,
    url: brandsAssets[Brands.TIKI].logo,
    hero: brandsAssets[Brands.TIKI].hero,
    companyUrl: 'https://www.tikigroup.eu/',
    hide: true,
  },
] satisfies BrandListItem[];

export const timeZoneOffsetRegex = /\(([^)]+)\)/;
export const DEFAULT_LANGUAGE = 'en';
export const address = {
  postalCode: {
    regex: /^[a-zA-Z\d\- ]+$/,
    maxLength: 20,
  },
  cityMaxLength: 100,
  regionMaxLength: 100,
  pattern: /^[\p{L}\p{Nd}'"\-–.,#&/() ]+$/u,
};

export const userNamePattern = /^[\p{L}\p{Nd}'\-. ]+$/u;
export const defaultMaxLength = 255;
export const parameterInvalidValue = -32760;

export const noRegion = {
  name: 'None',
  code: 'NONE',
};

export const vatNumberFormats = [
  { code: 'AT', vatPrefix: 'AT', vatNumberRegex: new RegExp('^U[0-9]{8}$') }, //Austria
  { code: 'BE', vatPrefix: 'BE', vatNumberRegex: new RegExp('^0[0-9]{9}$') }, //Belgium
  { code: 'BG', vatPrefix: 'BG', vatNumberRegex: new RegExp('^[0-9]{9,10}$') }, //Bulgaria
  { code: 'CY', vatPrefix: 'CY', vatNumberRegex: new RegExp('^[0-9]{8}[A-Z]$') }, // Cyprus
  { code: 'CZ', vatPrefix: 'CZ', vatNumberRegex: new RegExp('^[0-9]{8,10}$') }, //Czech Republic
  { code: 'DE', vatPrefix: 'DE', vatNumberRegex: new RegExp('^[0-9]{9}$') }, //Germany
  { code: 'DK', vatPrefix: 'DK', vatNumberRegex: new RegExp('^[0-9]{8}$') }, //Denmark
  { code: 'EE', vatPrefix: 'EE', vatNumberRegex: new RegExp('^[0-9]{9}$') }, //Estonia
  { code: 'GR', vatPrefix: 'EL', vatNumberRegex: new RegExp('^[0-9]{9}$') }, //Greece
  { code: 'ES', vatPrefix: 'ES', vatNumberRegex: new RegExp('^[0-9A-Z][0-9]{7}[0-9A-Z]$') }, //Spain
  { code: 'FI', vatPrefix: 'FI', vatNumberRegex: new RegExp('^[0-9]{8}$') }, //Finland
  { code: 'FR', vatPrefix: 'FR', vatNumberRegex: new RegExp('^[0-9A-Z]{2}[0-9]{9}$') }, //France
  { code: 'GB', vatPrefix: 'GB', vatNumberRegex: new RegExp('^(([0-9]{9})|([0-9]{12})|(GD[0-9]{3})|(HA[0-9]{3}))$') }, //United Kingdom
  { code: 'HR', vatPrefix: 'HR', vatNumberRegex: new RegExp('^[0-9]{11}$') }, //Croatia
  { code: 'HU', vatPrefix: 'HU', vatNumberRegex: new RegExp('^[0-9]{8}$') }, //Hungary
  {
    code: 'IE',
    vatPrefix: 'IE',
    vatNumberRegex: new RegExp('^(([0-9]([0-9A-Z]|\\*|\\+)[0-9]{5}[A-Z])|([0-9]{7}[A-Z]{2}))$'),
  }, //Ireland
  { code: 'IT', vatPrefix: 'IT', vatNumberRegex: new RegExp('^[0-9]{11}$') }, //Italy
  { code: 'LT', vatPrefix: 'LT', vatNumberRegex: new RegExp('^([0-9]{9}|[0-9]{12})$') }, //Lithuania
  { code: 'LU', vatPrefix: 'LU', vatNumberRegex: new RegExp('^[0-9]{8}$') }, //Luxembourg
  { code: 'LV', vatPrefix: 'LV', vatNumberRegex: new RegExp('^[0-9]{11}$') }, //Latvia
  { code: 'MT', vatPrefix: 'MT', vatNumberRegex: new RegExp('^[0-9]{8}$') }, //Malta
  { code: 'NL', vatPrefix: 'NL', vatNumberRegex: new RegExp('^[0-9]{9}B[0-9]{2}$') }, //Netherlands
  { code: 'PL', vatPrefix: 'PL', vatNumberRegex: new RegExp('^[0-9]{10}$') }, //Poland
  { code: 'PT', vatPrefix: 'PT', vatNumberRegex: new RegExp('^[0-9]{9}$') }, //Portugal
  { code: 'RO', vatPrefix: 'RO', vatNumberRegex: new RegExp('^[0-9]{2,10}$') }, //Romania
  { code: 'SE', vatPrefix: 'SE', vatNumberRegex: new RegExp('^[0-9]{12}$') }, //Sweden
  { code: 'SI', vatPrefix: 'SI', vatNumberRegex: new RegExp('^[0-9]{8}$') }, //Slovenia
  { code: 'SK', vatPrefix: 'SK', vatNumberRegex: new RegExp('^[0-9]{10}$') }, //Slovakia
];

export const KEYBOARD_KEYS = {
  ENTER: 'Enter',
  ESCAPE: 'Escape',
  SPACE: 'Space',
};
